import React from 'react';

import { Box, Avatar, Typography } from '@mui/material';

import { SmsConversationType } from '../types';
import {
  getTalentName,
  getLastMessagePreview,
  getFormattedDate,
} from '../utils';

interface SmsConversationItemProps {
  conversation: SmsConversationType;
  isSelected: boolean;
  onClick: () => void;
}

const SmsConversationItem: React.FC<SmsConversationItemProps> = ({
  conversation,
  isSelected,
  onClick,
}) => {
  const talentName = getTalentName(conversation);
  const avatar = conversation.talent?.avatar?.avatar;

  return (
    <Box
      display="flex"
      alignItems="flex-start"
      p={1}
      mb={1}
      borderRadius={2}
      sx={{
        cursor: 'pointer',
        background: isSelected ? '#F5F5F5' : 'transparent',
        '&:hover': {
          background: '#F5F5F5',
        },
      }}
      onClick={onClick}
    >
      <Avatar
        src={avatar || undefined}
        sx={{ width: 44, height: 44, mr: 2, bgcolor: '#222' }}
      >
        {talentName.charAt(0).toUpperCase()}
      </Avatar>
      <Box flex={1} minWidth={0}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography fontWeight={600} fontSize={16} noWrap>
            {talentName}
          </Typography>
          <Typography fontSize={12} color="text.secondary">
            {getFormattedDate(conversation.last_sms.created_at)}
          </Typography>
        </Box>
        <Typography
          fontSize={13}
          color="text.secondary"
          noWrap
          sx={{ mt: 0.5 }}
        >
          {getLastMessagePreview(conversation.last_sms.content)}
        </Typography>
      </Box>
    </Box>
  );
};

export default SmsConversationItem;
